export const adjustEnLocale = (language: string): string => (language === 'en' ? 'en-GB' : language)
